import timezones from './timezones.json';

export const ValidTimeZone = (tz) => {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz });
    return true;
  } catch (err) {
    return false;
  }
};

export const getTimeZoneCodes = () => {
  const set = new Set();

  timezones.forEach((tz) => {
    if (tz.code && ValidTimeZone(tz.code)) {
      set.add(tz.code);
    }
  });

  return Array.from(set).sort();
};

export const getTimeZones = () => {
  const preferredRegions = ['Asia', 'Europe', 'America', 'Africa'];

  return getTimeZoneCodes().filter((tz) =>
    preferredRegions.some((region) => tz.startsWith(region))
  );
};